import { render, staticRenderFns } from "./BookingRoomList.vue?vue&type=template&id=68230da8&scoped=true&"
import script from "./BookingRoomList.vue?vue&type=script&lang=js&"
export * from "./BookingRoomList.vue?vue&type=script&lang=js&"
import style0 from "./BookingRoomList.vue?vue&type=style&index=0&id=68230da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68230da8",
  null
  
)

component.options.__file = "BookingRoomList.vue"
export default component.exports